import "babel-polyfill";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
// import ReactGA from 'react-ga';
import bugsnag from "bugsnag-js";
import createPlugin from "bugsnag-react";
import LogRocket from 'logrocket';
import configureStore from "./store/configureStore";

// import createHistory from "history/createBrowserHistory";

import history from "./utils/history";


import App from "./App";
import { unregister } from "./registerServiceWorker";

import { isMobile } from "./utils/util";
import api from "./utils/api";

let initialState = {};
// const history = createHistory();
const store = configureStore(initialState, history);

// if (process.env.REACT_APP_ENV === "prod") {
//   // ReactPixel.init(process.env.REACT_APP_FACEBOOK_PIXEL_ID);
//   // ReactGA.initialize(process.env.REACT_APP_GA_TAG);
//   LogRocket.init('bovneu/helloava');
// }

const bugsnagClient = bugsnag({
  apiKey: process.env.REACT_APP_BUGSNAG_KEY,
  notifyReleaseStages: ["production", "staging"],
  beforeSend: function(report) {
      // if (process.env.REACT_APP_ENV === "prod" && LogRocket.sessionURL) {
      //     report.updateMetaData("logrocket", {
      //       urlAtTime: LogRocket.sessionURL
      //     });
      // }
  }
});
const ErrorBoundary = bugsnagClient.use(createPlugin(React));
try {
  window.zE("webWidget", "hide");  
} catch (error) {
  console.log(error);
}


ReactDOM.render(
  <ErrorBoundary>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </Provider>
  </ErrorBoundary>,
  document.getElementById("app-content")
);

// Unregister the service worker since it can cache old bundle js and cause blank
// page when a new bundle is deployed.
unregister();



// WEBPACK FOOTER //
// ./src/index.js